import type { ScreenModule } from "../../../app/screen-module";
import { ProviderRulesPage } from "../pages";

export default {
	id: "tenant-admin.provider-rules",
	path: "/admin/provider-rules",
	area: "tenant-admin",
	navGroup: "利用できるもの",
	label: "Provider利用ルール",
	roles: ["tenant_admin", "platform_admin"],
	backing: "MOCK_ONLY",
	enabled: true,
	component: ProviderRulesPage,
} satisfies ScreenModule;
